// --------------------------------------------------------------
// Created On: 2025-03-14
// Author: Dimitra Weinstein
//
// Last Modified: 2026-03-31
// Modified By: Dimitra Weinstein
//
// Copyright 2025 - 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";

// A single report in a list of reports.
export default function LiftStationReportListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="lift-station-report-list-row">
      <span>{props.name}</span>
    </div>
  );
}

interface Props {
  reportLiftStationId: number | null;
  name: string;
}
